




	// @ts-ignore
    import _ from './Icon.ts'; export default _;
